export default __webpack_public_path__ + "7815ea9fc7c1ecb1bdd9c39464bc2c9e.webp";